import { readFileSync } from "fs"
import yaml from "js-yaml"

function loadConfig(): Record<string, any> {
    let env = ""

    if (process.env.APP_ENV) {
        env = process.env.APP_ENV
    } else {
        if (window.location.hostname.includes("beta.anio.cloud")) {
            env = "beta"
        } else if (window.location.hostname.includes("hq.anio.cloud")) {
            env = "hq"
        } else if (window.location.hostname.includes("nightly.anio.cloud")) {
            env = "nightly"
        } else if (window.location.hostname.includes("nightly-a7.anio.cloud")) {
            env = "nightly-a7"
        } else if (window.location.hostname.includes("anio.cloud")) {
            env = "production"
        }
    }

    let configData = ""
    switch (env) {
        case "production":
            configData = readFileSync("config/production.yaml", "utf8")
            break

        case "beta":
            configData = readFileSync("config/beta.yaml", "utf8")
            break

        case "hq":
            configData = readFileSync("config/hq.yaml", "utf8")
            break

        case "nightly":
            configData = readFileSync("config/nightly.yaml", "utf8")
            break

        case "nightly-a7":
            configData = readFileSync("config/nightly-a7.yaml", "utf8")
            break

        case "local":
            configData = readFileSync("config/local.yaml", "utf8")
            break

        default:
            throw new Error("No environment set.")
    }

    return yaml.load(configData) as Record<string, any>
}

export default loadConfig()
